/** Maps API row (camelCase or PascalCase) to grid DTO. */
export function mapFamilyFestAttendeeGridRow(raw) {
    const r = raw;
    return {
        id: String(r.id ?? r.Id ?? ''),
        invitationId: String(r.invitationId ?? r.InvitationId ?? ''),
        vdkEventId: String(r.vdkEventId ?? r.VDKEventId ?? ''),
        fullName: String(r.fullName ?? r.FullName ?? ''),
        firstName: String(r.firstName ?? r.FirstName ?? ''),
        middleName: (r.middleName ?? r.MiddleName),
        lastName: String(r.lastName ?? r.LastName ?? ''),
        email: String(r.email ?? r.Email ?? ''),
        companyName: (r.companyName ?? r.CompanyName),
        totalPersonCount: Number(r.totalPersonCount ?? r.TotalPersonCount ?? 0),
        expectedNoOfPersons: (r.expectedNoOfPersons ?? r.ExpectedNoOfPersons),
        isWaitingList: Boolean(r.isWaitingList ?? r.IsWaitingList),
        memberCount: Number(r.memberCount ?? r.MemberCount ?? 0),
        dateOfBirth: (r.dateOfBirth ?? r.DateOfBirth),
        numOfCars: Number(r.numOfCars ?? r.NumOfCars ?? 0),
        comingWith: (r.comingWith ?? r.ComingWith),
        travelMode: (r.travelMode ?? r.TravelMode),
        pickupLocationName: (r.pickupLocationName ?? r.PickupLocationName),
        wantsVdkAccommodation: (r.wantsVdkAccommodation ?? r.WantsVdkAccommodation),
        isWheelchairDependent: Boolean(r.isWheelchairDependent ?? r.IsWheelchairDependent),
        isComingToEvent: Boolean(r.isComingToEvent ?? r.IsComingToEvent),
        invitationStatus: String(r.invitationStatus ?? r.InvitationStatus ?? ''),
        isInvitationArchived: Boolean(r.isInvitationArchived ?? r.IsInvitationArchived),
        registrationDate: (r.registrationDate ?? r.RegistrationDate),
        createdDate: String(r.createdDate ?? r.CreatedDate ?? ''),
        lastModifiedDate: (r.lastModifiedDate ?? r.LastModifiedDate),
        attendanceStatus: (r.attendanceStatus ?? r.AttendanceStatus),
        reasonForCancellation: (r.reasonForCancellation ?? r.ReasonForCancellation),
        preferredAirport: (r.preferredAirport ?? r.PreferredAirport)
    };
}
